import { render, staticRenderFns } from "./MealStatusPanel.vue?vue&type=template&id=19cedd3c&scoped=true"
import script from "./MealStatusPanel.vue?vue&type=script&lang=js"
export * from "./MealStatusPanel.vue?vue&type=script&lang=js"
import style0 from "./MealStatusPanel.vue?vue&type=style&index=0&id=19cedd3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cedd3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
